import { render, staticRenderFns } from "./uppy_entity_contracts.vue?vue&type=template&id=0de5828a&scoped=true"
import script from "./uppy_entity_contracts.vue?vue&type=script&lang=js"
export * from "./uppy_entity_contracts.vue?vue&type=script&lang=js"
import style0 from "./uppy_entity_contracts.vue?vue&type=style&index=0&id=0de5828a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de5828a",
  null
  
)

export default component.exports